import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/tab_img.png'
import _imports_1 from '../assets/step.gif'
import _imports_2 from '../assets/get.png'
import _imports_3 from '../assets/ad.png'
import _imports_4 from '../assets/ad1.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "el_col" }
const _hoisted_3 = { class: "el_row" }
const _hoisted_4 = {
  class: "el_row",
  style: {"text-align":"left","width":"80%"}
}
const _hoisted_5 = { style: {"margin-left":"10px","color":"white"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RowScollView = _resolveComponent("RowScollView")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createVNode(_component_el_container, { class: "home" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                src: _imports_0,
                alt: "logo",
                class: "img_title"
              }, null, -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_RowScollView)
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "el_col",
                style: {"align-items":"flex-start","width":"70%","margin-top":"20px"}
              }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  style: {"width":"300px"},
                  alt: "输入手机号"
                })
              ], -1)),
              _createVNode(_component_el_input, {
                class: "el_phone_input",
                type: "number",
                maxlength: "11",
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
                placeholder: _ctx.input_phone_hinder,
                pattern: _ctx.pone_pattern
              }, null, 8, ["modelValue", "placeholder", "pattern"]),
              _createElementVNode("img", {
                src: _imports_2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getGo())),
                class: "img"
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_checkbox, {
                  onChange: _ctx.handleCheckChanged,
                  modelValue: _ctx.checked,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event)),
                  size: "large"
                }, null, 8, ["onChange", "modelValue"]),
                _createElementVNode("p", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createTextVNode(" 我已阅读并同意")),
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.readInfo()))
                  }, "《服务协议》"),
                  _cache[7] || (_cache[7] = _createTextVNode("及")),
                  _createElementVNode("span", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.readInfo()))
                  }, "《隐私政策》"),
                  _cache[8] || (_cache[8] = _createTextVNode("，知悉业务说明并用该号码登录办理 "))
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "el_row" }, [
                _createElementVNode("p", { class: "font_size" }, [
                  _createTextVNode(" 开通咪咕悦看超级会员,"),
                  _createElementVNode("strong", null, "标准资费20元/月"),
                  _createTextVNode("， 以"),
                  _createElementVNode("strong", null, "话费支付"),
                  _createTextVNode("，具体以实际扣费为准， 支付成功后"),
                  _createElementVNode("strong", null, "立即生效，有效期3年（36个自然月），如双方在有效期届满前无异议，有效期自动续展，每次续展3年。有效期内变更/退订/销户/携转，无需承担相应的违约责任。"),
                  _createTextVNode(" 可随时取消，取消"),
                  _createElementVNode("strong", null, "立即生效"),
                  _createTextVNode(",当前周期内可继续享受权益，次月起不再扣费。 ")
                ])
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("strong", { style: {"font-size":"20px","text-align":"center","color":"white"} }, "客服热线：4009685118", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("img", {
                src: _imports_3,
                alt: "logo",
                class: "img_title"
              }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_4,
                alt: "logo",
                style: {"margin-top":"20px"},
                class: "img_title"
              }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("p", { style: {"color":"white","font-size":"20px"} }, "业务规则", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("div", {
                class: "el_col",
                style: {"color":"white","font-size":"18px","align-items":"flex-start","text-align":"left"}
              }, [
                _createElementVNode("p", { style: {"margin-left":"20px","margin-right":"20px"} }, [
                  _createTextVNode("1、产品名称：咪咕悦看超级会员。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 2、产品资费："),
                  _createElementVNode("strong", null, "话费"),
                  _createTextVNode("支付"),
                  _createElementVNode("strong", null, "20元/月"),
                  _createElementVNode("br"),
                  _createTextVNode(" 3、产品对象："),
                  _createElementVNode("strong", null, "中国移动用户（不含港澳台用户）"),
                  _createTextVNode("。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 4、生效时间：支付成功后"),
                  _createElementVNode("strong", null, "立即生效，有效期3年（36个自然月），如双方在有效期届满前无异议，有效期自动续展，每次续展3年。有效期内变更/退订/销户/携转，无需承担相应的违约责任。"),
                  _createTextVNode("， 可随时取消，取消"),
                  _createElementVNode("strong", null, "立即生效"),
                  _createTextVNode("，当前周期内可继续享受权益，次月起不再扣费。 "),
                  _createElementVNode("br"),
                  _createTextVNode(" 5、产品内容： "),
                  _createElementVNode("strong", null, "咪咕悦看超级会员"),
                  _createTextVNode("可享咪咕悦看APP内海量短剧畅看（特殊版权内容除外）、海量图书畅读（特殊版权内容除外）等权益。更详细权益介绍可至咪咕悦看APP会员界面查看。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 6、权益领取："),
                  _createElementVNode("strong", null, "咪咕悦看超级会员权益"),
                  _createTextVNode("订购成功后，权益无需客户领取，立即直充到账，请"),
                  _createElementVNode("strong", null, "下载咪咕悦看"),
                  _createTextVNode("APP，用订购手机号码登录后，点击下方短剧导航-选择会员，即可观看喜欢的短剧。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 7、"),
                  _createElementVNode("strong", null, "同一连续包月产品，每个用户每月仅能订购一次。"),
                  _createTextVNode("咪咕短剧精品会员系列，产品权益可同时生效，短剧任选次数可叠加；咪咕悦看超级会员和咪咕短剧标准会员的连续及非连续包，可同类型及互相间叠加有效期，叠加后优先使用咪咕悦看超级会员权益，其次是咪咕短剧标准会员，无法和任何其他会员类型包叠加；在购买咪咕悦看超级会员后，如果账号内仍有未过期的咪咕短剧标准会员，将会优先生效咪咕悦看超级会员权益，剩余的咪咕短剧标准会员到期时间将顺延，待咪咕悦看超级会员过期时继续生效咪咕短剧标准会员。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 8、办理须知：订购业务前请仔细阅读活动规则，订购本业务，即视为同意接受本业务及其相关活动的所有条款或规则。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 9、"),
                  _createElementVNode("strong", null, "退订方式：所属省份 10086 热线、当地中国移动营业厅、中国移动 APP。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 10、如发生不可抗力、情势变更情形（包括但不限于因自然灾害、司法行政命令、公共服务故障、设备与系统维护或故障、网络信息与数据安全、外呼电话无法联系用户等）造成您订购、兑换、使用或变更相关权益障碍、延后或内容变更等情形，我们可依据法律法规的规定主张免责、采取适当应对措施。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 11、客服咨询："),
                  _createElementVNode("br"),
                  _createTextVNode(" ①客服热线：4009685118，客服工作时间：周一到周日8:00-21:00，节假日无休"),
                  _createElementVNode("br"),
                  _createTextVNode(" ②在线客服：咪咕悦看APP-我的-帮助与客服-联系人工，工作时间：周一到周日08:30-22:00，节假日无休。 ")
                ])
              ], -1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.centerDialogVisible,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
          width: "500",
          "align-center": ""
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createElementVNode("div", { style: {"width":"100%","text-align":"left","font-size":"20px"} }, [
              _createElementVNode("p", null, "尊敬的客户："),
              _createElementVNode("p", null, "根据《中华人民共和国反恐怖主义法》、 《全国人民代表大会常务委员会关于加强网络信息保护的决定》、 《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）等国家法律法规的要求， 为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。"),
              _createElementVNode("p", null, " 为向客户提供优质、个性化的服务，包括但不限于提供通信服务、 保障通信服务安全、改善服务质量、推介个性化产品等， 我公司将遵循合法、正当、必要的原则， 按照法律法规规定或协议约定使用留存客户个人信息， 并妥善保管，严格保密，依法保护客户个人信息。")
            ], -1)
          ])),
          _: 1,
          __: [17]
        }, 8, ["modelValue"]),
        (_ctx.showToast)
          ? (_openBlock(), _createBlock(_component_CustomDialog, {
              key: 0,
              close: _ctx.handColse
            }, null, 8, ["close"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}